module.exports = __webpack_public_path__ + "images/application/templates/welcome@2x-a89d47e8.png";